export const HighlightComments = (data) => {
  if (typeof data !== 'string') return '';

  const headerRegex =
    /(?<=<br\s*\/?>|^)\d{2}\s[A-Za-z]{3}\s\d{4}\s\d{2}:\d{2}:\d{2}\s(?:AM|PM)(?=,\s*Updated by)/g;

  const starts = [];
  let m;
  while ((m = headerRegex.exec(data)) !== null) {
    starts.push(m.index);
  }

  if (starts.length === 0) return data;

  let result = data.slice(0, starts[0]);

  for (let i = 0; i < starts.length; i++) {
    const start = starts[i];
    const end = i + 1 < starts.length ? starts[i + 1] : data.length;
    let block = data.slice(start, end);

    block = block.replace(/Comments:([\s\S]*)$/, (full, rest) => {
      const cleaned = rest
        .replace(/<br\s*\/?>/gi, '')
        .replace(/\s+$/, '');
      return `Comments:<span class='highlighted-Comment'>${cleaned}</span>`;
    });

    block = block.replace(/\s+$/, '');

    result += block;

    if (i + 1 < starts.length) {
      result += '<br/><br/><br/>';
    }
  }

  return result;
};